<div class="parent-mermaid" *ngIf="loaded">
    <div id="mermaid-diagram" [innerHtml]="mermaidDefinition"></div>
</div>